import { render, staticRenderFns } from "./PhoneFilter.vue?vue&type=template&id=68f888a4&scoped=true"
import script from "./PhoneFilter.vue?vue&type=script&lang=ts"
export * from "./PhoneFilter.vue?vue&type=script&lang=ts"
import style0 from "./PhoneFilter.vue?vue&type=style&index=0&id=68f888a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f888a4",
  null
  
)

export default component.exports